module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst costCenter = (resourceData || {}).attributes || {}\nlet groupTitle = 'UNKNOWN_DATE'\nconst titleParts = []\nif(costCenter.projectTermID){\ntitleParts.push(`#${costCenter.projectTermID}`)\nif(costCenter.projectTermStartTS)   titleParts.push(`${utils.moment(costCenter.projectTermStartTS).format('DD.MM.YYYY')}`);\nif(costCenter.projectTermTitle)     titleParts.push(`${costCenter.projectTermTitle}`);\nif(costCenter.projectTermLocation)  titleParts.push(`${costCenter.projectTermLocation}`);\ngroupTitle = titleParts.join(' - ')\n} else if(costCenter.type === 'customFlat'){\ngroupTitle = storage.__('table.costCenters.additionalCostCenters')\n}\n%>\n<tbody>\n<tr>\n<td colspan=\"<%= config.maxNrOfColumns + 1 %>\">\n<%= groupTitle %>\n</td>\n</tr>\n</tbody>"
  , __filename = "components/templates/customers/documents/invoices/costCenters/groupRow.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const costCenter = (resourceData || {}).attributes || {}
let groupTitle = 'UNKNOWN_DATE'
const titleParts = []
if(costCenter.projectTermID){
titleParts.push(`#${costCenter.projectTermID}`)
if(costCenter.projectTermStartTS)   titleParts.push(`${utils.moment(costCenter.projectTermStartTS).format('DD.MM.YYYY')}`);
if(costCenter.projectTermTitle)     titleParts.push(`${costCenter.projectTermTitle}`);
if(costCenter.projectTermLocation)  titleParts.push(`${costCenter.projectTermLocation}`);
groupTitle = titleParts.join(' - ')
} else if(costCenter.type === 'customFlat'){
groupTitle = storage.__('table.costCenters.additionalCostCenters')
}

    ; __line = 14
    ; __append("\n<tbody>\n<tr>\n<td colspan=\"")
    ; __line = 17
    ; __append(escapeFn( config.maxNrOfColumns + 1 ))
    ; __append("\">\n")
    ; __line = 18
    ; __append(escapeFn( groupTitle ))
    ; __append("\n</td>\n</tr>\n</tbody>")
    ; __line = 21
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/customers/documents/invoices/costCenters/groupRow.ejs

}